<script>
  import { signinemail, doLogin } from '../helpers/login';

  import LoginProviders from './LoginProviders.svelte';
  let email, password, errorMsg;
  let loading = false;

  const go = () => {
    try {
      DD_LOGS.logger.info('Email login');
    } catch (error) {
      console.error(error);
    }
    loading = true;
    signinemail(email, password)
      .then((userCredential) => {
        // Signed in
        var user = userCredential.user;
        doLogin(user);
      })
      .catch((error) => {
        console.error(error);
        //var errorCode = error.code;
        errorMsg = error.message;
      })
      .finally(() => (loading = false));
  };
</script>

{#if errorMsg}
  <div class="message is-danger">
    <div class="message-body">
      There was an error with sign in. <br /><br />
      {errorMsg}
    </div>
  </div>
{/if}

<div>
  <div class="field">
    <div class="control">
      <input
        bind:value={email}
        class="input is-medium"
        type="text"
        placeholder="you@example.com"
      />
    </div>
  </div>
  <div class="field">
    <div class="control">
      <input
        bind:value={password}
        password
        class="input is-medium"
        type="password"
        placeholder="**********"
      />
    </div>
  </div>
  <div class="field">
    <button
      class="button is-block is-primary is-fullwidth is-medium"
      disabled={!email || !password}
      class:loading
      on:click={go}
    >
      Sign in
    </button>
  </div>
</div>

<hr />
<p class="subtitle has-text-centered">or</p>

<LoginProviders />
